// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img_profile_shape {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border-radius: 50px;
  border: 1px solid;
}

.text_color_account {
  color: gray;
  font-size: 90%;
}

.sub_text_color_account {
  color: rgb(194, 194, 194);
  font-size: 80%;
}

.sub_text_color_account_alltext {
  color: #AAA;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.background_color_showboxes {
  background-color: #fff;
  padding-top: 1%;
  padding-bottom: 1%;
  border-radius: 8px;
  border: 1px solid #DCDCDC;
  cursor: pointer;
}

.sub_text_color_account_alltext_show {
  color: #AAA;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub_text_color_account_alltext_show_actual {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

#color_icon_right {
  color: #A9A9A9;
}

.box_height_profile {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1 {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1::-webkit-scrollbar {
  display: none;
}

.background_color_line {
  background-color: #F1F1F1 !important;
  color: white !important;
  border: 2px solid #F1F1F1 !important;
}

.img_verified_size {
  width: 8%;
  padding-right: 3%;
}

#style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar {
  width: 12px;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #548DFF;
}

.disabled_button {
  background-color: #548DFF !important;
  cursor: no-drop !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
}

.btnn {
  border: 2px solid #0069D9;
  color: #0069D9;
  background-color: white;
  padding: 2px 5px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer !important;
}

.margin_neg_button {
  top: 80px;
  position: absolute;
  left: 90px;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboardpages/dashboardpages.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,uBAAA;EACA,oCAAA;AAAJ;;AAGA;EACI,SAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,oDAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,oDAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,0BAAA;AAAJ;;AAMA;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAHJ;;AAMA;EACI,SAAA;EACA,kBAAA;EACA,UAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AAHJ","sourcesContent":[".img_profile_shape {\n    height: 100px;\n    width: 100px;\n    object-fit: fill;\n    border-radius: 50px;\n    border: 1px solid;\n}\n\n.text_color_account {\n    color: gray;\n    font-size: 90%;\n}\n\n.sub_text_color_account {\n    color: rgb(194, 194, 194);\n    font-size: 80%;\n}\n\n.sub_text_color_account_alltext {\n    color: #AAA;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.background_color_showboxes {\n    background-color: #fff;\n    padding-top: 1%;\n    padding-bottom: 1%;\n    border-radius: 8px;\n    border:1px solid #DCDCDC;\n    // margin: 0px 20px 0px 0px;\n    cursor: pointer;\n}\n\n.sub_text_color_account_alltext_show {\n    color: #AAA;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.sub_text_color_account_alltext_show_actual {\n    color: #000;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n#color_icon_right {\n    color:#A9A9A9;\n}\n\n.box_height_profile {\n    height: 75vh;\n    overflow-y: scroll;\n}\n\n.box_height_profile1 {\n    height: 75vh;\n    overflow-y: scroll;\n}\n\n.box_height_profile1::-webkit-scrollbar {\n    display: none;\n}\n\n.background_color_line {\n    background-color: #F1F1F1 !important;\n    color: white !important;\n    border: 2px solid #F1F1F1 !important;\n}\n\n.img_verified_size {\n    width: 8%;\n    padding-right: 3%;\n}\n\n#style-2::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n    background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar {\n    width: 12px;\n    background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n    background-color: #548DFF;\n}\n\n.disabled_button {\n    background-color: #548DFF !important;\n    cursor: no-drop !important;\n\n}\n\n// upload file button \n\n.upload-btn-wrapper {\n    position: relative;\n    overflow: hidden;\n    display: inline-block;\n    cursor: pointer;\n}\n\n.btnn {\n    border: 2px solid #0069D9;\n    color: #0069D9;\n    background-color: white;\n    padding: 2px 5px;\n    border-radius: 50px;\n    font-size: 10px;\n    font-weight: bold;\n    cursor: pointer !important;\n}\n\n.margin_neg_button {\n    top: 80px;\n    position: absolute;\n    left: 90px;\n}\n\n.upload-btn-wrapper input[type=file] {\n    font-size: 100px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
